import React from 'react';
import { GUARANTEE_LINE, RATING_LINE } from './constants';
export function TrustLine({
  className = ''
}: {
  className?: string;
}) {
  return <div className={`space-y-1 text-center ${className}`} data-id="element-176" data-mp="3ox3yqi8mbnub">
      <p className="text-[13px] font-semibold text-graphite sm:text-sm" data-id="element-177" data-mp="3kw1z40ash9rt">{RATING_LINE}</p>
      <p className="text-[13px] font-semibold text-petrol sm:text-sm" data-id="element-178" data-mp="3fya6t568fln3">{GUARANTEE_LINE}</p>
    </div>;
}